import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "sonner";

// Completely suppress ResizeObserver errors - more robust approach
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver') || 
      (typeof args[0] === 'string' && args[0].includes('ResizeObserver'))) {
    return;
  }
  resizeObserverErr.apply(window.console, args);
};

// Suppress ResizeObserver in error events
window.addEventListener('error', (e) => {
  if (e.message?.includes?.('ResizeObserver') || e.error?.message?.includes?.('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);

// Suppress in unhandled rejection
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes?.('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);

// Polyfill/override ResizeObserver to be more tolerant
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver callback errors
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" richColors />
  </React.StrictMode>,
);

// Register the service worker so the browser allows "Install as app".
// We don't cache anything aggressively (see /public/sw.js); the SW exists
// mostly to satisfy Chrome's installability checks.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('SW registration failed:', err);
    });
  });
}
